import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGRecord from 'visitor-ui-component-library-icons/icons/SVGRecord';
import { IconButton } from 'conversations-visitor-experience-components/visitor-widget/SpotlightLauncherShell';
import unescapedText from 'I18n/utils/unescapedText';
import { useAppSelector } from '../../buildStore';
import { getIsUngatedForVoiceInput } from '../../widget-data/selectors/widgetDataSelectors';
import { useVoiceInput } from '../hooks/useVoiceInput';
import { VOICE_INPUT_AWAITING_PERMISSION, VOICE_INPUT_RECORDING, VOICE_INPUT_ERROR } from '../constants/voiceInputConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const SpotlightVoiceInput = ({
  isButton = false,
  disabled = false
}) => {
  const voiceInputEnabled = useAppSelector(getIsUngatedForVoiceInput);
  const {
    status,
    onStart
  } = useVoiceInput();
  if (!voiceInputEnabled) return null;
  const isAwaitingPermission = status === VOICE_INPUT_AWAITING_PERMISSION;
  const isRecording = status === VOICE_INPUT_RECORDING;
  const isError = status === VOICE_INPUT_ERROR;
  const isDisabled = disabled || isAwaitingPermission || isRecording;
  const ariaLabel = isError ? unescapedText('conversations-visitor-ui.voiceInput.micPermissionDenied') : unescapedText('conversations-visitor-ui.voiceInput.startRecording');
  return /*#__PURE__*/_jsx(IconButton, {
    "aria-label": ariaLabel,
    "aria-hidden": isButton,
    tabIndex: isButton ? -1 : 0,
    "data-test-id": "voice-input-button",
    disabled: isDisabled,
    onClick: isButton || isDisabled ? undefined : onStart,
    style: isButton ? {
      pointerEvents: 'none'
    } : undefined,
    children: /*#__PURE__*/_jsx(VizExIcon, {
      size: "14px",
      icon: /*#__PURE__*/_jsx(SVGRecord, {})
    })
  });
};
SpotlightVoiceInput.displayName = 'SpotlightVoiceInput';
export default SpotlightVoiceInput;